import type { ReactNode } from 'react';
import { classes } from '@src/components/layout/space';
import './IconBox.css';

export type IconBoxSize = 'sm' | 'md' | 'lg' | 'xl';

export interface IconBoxProps {
  children: ReactNode;
  size?: IconBoxSize;
}

export function IconBox({ children, size = 'md' }: IconBoxProps) {
  return <span className={classes('icon-box', `icon-box--${size}`)}>{children}</span>;
}
